import React, { useEffect } from 'react';
import PatientDetailsFormFields from './PatientDetailsFormFields';
import { Form } from 'antd';
import styled from '@emotion/styled';
import useUser from '@vl-core/hooks/useUser';
import moment from 'moment';

const FormContainer = styled.div`
  input {
    max-height: unset;
    min-height: 48px;
    font-weight: 400;
    font-size: 16px;
  }

  .ant-form-item-label {
    font-weight: 500;
    font-size: 16px;
  }
`;

export type InuviPatientDetailsData = {
  patient_title: string;
  patient_gender: string;
  patient_first_name: string;
  patient_last_name: string;
  patient_dob: string | null;
  postcode: string;
  addline1: string;
  addline2: string;
  city: string;
  country: string;
  tel_no: string;
};

function getSurveyValuesFromUser(user: ReturnType<typeof useUser>) {
  return {
    patient_title: user.title || '',
    patient_gender: user.sex || '',
    patient_first_name: user.first_name || '',
    patient_last_name: user.last_name || '',
    patient_dob: user.dob ? moment(user.dob).format('DD/MM/YYYY') : null,
    postcode: user.postcode || '',
    addline1: user.addline1 || '',
    addline2: user.addline2 || '',
    addline3: user.addline3 || '',
    addline4: user.addline4 || '',
    country: user.country || '',
    tel_no: user.tel_mobile_no ? `+${user.tel_mobile_no}` : ''
  };
}

const RandoxInuviSurveyComponent = ({
  onLoadPatientData
}: {
  onLoadPatientData: (data: InuviPatientDetailsData) => void;
}) => {
  const [form] = Form.useForm();
  const user = useUser();

  useEffect(() => {
    if (!user || user?.user_type_code !== 'PATIENT') return;
    const formValues = getSurveyValuesFromUser(user);
    form.setFieldsValue(formValues);
    onLoadPatientData({ ...formValues, city: formValues.addline4 });
  }, [user]);

  return (
    <FormContainer>
      <Form form={form} layout="vertical">
        <PatientDetailsFormFields readOnly />
      </Form>
    </FormContainer>
  );
};

export default RandoxInuviSurveyComponent;
